document.addEventListener('alpine:init', () => {
  Alpine.data('gbiTikTokSchedule', (config) => ({
    open: false,
    isVisible: false,
    reduceMotion: false,
    bidIndex: 0,
    showWinner: false,
    bids: (config && config.bids) || [],
    _io: null,
    _bidInterval: null,
    _winnerTimer: null,
    _resetTimer: null,
    _sectionUnload: null,

    init() {
      const self = this;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._io = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) {
          self.isVisible = true;
          if (!self.reduceMotion && self.bids.length > 0) self.startBidLoop();
          self._io.disconnect();
        }
      }, { threshold: 0.2 });
      this._io.observe(this.$el);

      this._sectionUnload = function (e) {
        if (self.$el && self.$el.closest('.shopify-section') === e.target) {
          self.destroy();
        }
      };
      document.addEventListener('shopify:section:unload', this._sectionUnload);
    },

    destroy() {
      if (this._bidInterval) { clearInterval(this._bidInterval); this._bidInterval = null; }
      if (this._winnerTimer) { clearTimeout(this._winnerTimer); this._winnerTimer = null; }
      if (this._resetTimer) { clearTimeout(this._resetTimer); this._resetTimer = null; }
      if (this._io) { this._io.disconnect(); this._io = null; }
      if (this._sectionUnload) { document.removeEventListener('shopify:section:unload', this._sectionUnload); this._sectionUnload = null; }
    },

    toggle() {
      this.open = !this.open;
    },

    startBidLoop() {
      const self = this;
      this._bidInterval = setInterval(function () {
        if (self.bidIndex < self.bids.length - 1) {
          self.bidIndex++;
        } else {
          // last bid reached — schedule winner reveal + loop reset
          if (self._bidInterval) { clearInterval(self._bidInterval); self._bidInterval = null; }
          self._winnerTimer = setTimeout(function () {
            self.showWinner = true;
            self._resetTimer = setTimeout(function () {
              self.showWinner = false;
              self.bidIndex = 0;
              self.startBidLoop();
            }, 2800);
          }, 700);
        }
      }, 900);
    }
  }));
});
